import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../utils/EncriptionStore";
import { Button, Box, CircularProgress } from "@mui/material";
import Select from "react-select";
import "./defaultcreatedrilldown.css";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import {
  checkdrilldown,
  getDrilldowndetailforupdated,
  getlistofcolumnformappingfirst,
  getlistofcolumnformappingsecond,
  getreporttitlefromondashbaord,
  updateMapDataForDrillDown,
  setDrilldownTypeCheckdashboard,
} from "../../actions/reportmanagement";

const UpdateDefaultCreateDrillDown = ({ open, onClose }) => {
  const [normalCustomQueryInputWidth, setNormalCustomQueryInputWidth] =
    useState(0);
  const [selectColumnForDrill, setSelectColumnForDrill] = useState([]);
  const [drilldownmessage, setDrillDownMessage] = useState("");
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [columnCount, setcolumnCount] = useState();
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectReportTitleDrilldown, setSelectReportTitleDrilldown] =
    useState("");
  const [tagBtnClicked, setTagBtnClicked] = useState(false);

  const apiData = useSelector((state) => state);

  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();

  const CustomeDetailOfReport = JSON.parse(
    localStorage.getItem("customeDetailOfReport")
  );

  useEffect(() => {
    const fetchDrilldownData = async () => {
      try {
        if (CustomeDetailOfReport?.enable_drilldown === "yes") {
          setLoading(true);
          await dispatch(
            getDrilldowndetailforupdated({
              master_report: CustomeDetailOfReport?.title,
              customer_id: user.customer_id,
              query: CustomeDetailOfReport?.query,
              type: CustomeDetailOfReport?.type,
              db_type: CustomeDetailOfReport?.connection_type,
              schema_name: CustomeDetailOfReport?.schema,
              database_type: user.database_type,
            })
          );
        } else if (
          CustomeDetailOfReport?.enable_drilldown === "no" &&
          CustomeDetailOfReport?.type !== "Table"
        ) {
          setSelectColumnForDrill({ Master_Column: [], DrillDown_Column: [] });
          setLoader(true);
          await dispatch(
            checkdrilldown({
              query: CustomeDetailOfReport?.query,
              type: CustomeDetailOfReport.type,
              db_type: CustomeDetailOfReport?.connection_type,
              schema_name: CustomeDetailOfReport?.schema,
              customer_id: user.customer_id,
              database_type: user.database_type,
            })
          );
          await dispatch(
            getreporttitlefromondashbaord({
              database_type: user.database_type,
              email: user.user_email_id,
              customer_id: user.customer_id,
              group_id: user.group_id,
            })
          );
        }
      } catch (error) {
        console.error("Error in UpdateDefaultCreateDrillDown:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDrilldownData();
  }, []);

  const dispatch = useDispatch();
  const reportdetaillist = apiData?.reportmanagement?.allReportDetail;
  const columndetailfirst = apiData?.reportmanagement?.getlistofcolumfirst;
  const columndetailsecond = apiData?.reportmanagement?.getlistofcolumsecond;
  const checkquerysupportdrilldown = apiData?.reportmanagement?.checkdrilldown;
  const getDrilldowndataforupdated =
    apiData?.reportmanagement?.getdrildowndataforupdate;
  const updateemapdatadrilldown =
    apiData?.reportmanagement?.updateemapdatafordrilldown;

  useEffect(() => {
    const normalCustomQueryInputDiv = document.getElementById(
      "normalCustomQueryInputId"
    );
    if (normalCustomQueryInputDiv) {
      const resizeObserver = new ResizeObserver(() => {
        const rect = normalCustomQueryInputDiv.getBoundingClientRect();
        setNormalCustomQueryInputWidth(rect.width);
      });
      resizeObserver.observe(normalCustomQueryInputDiv);
      return () => {
        resizeObserver.unobserve(normalCustomQueryInputDiv);
        resizeObserver.disconnect();
      };
    }
  }, []);

  const handleSelectReportNamedropfirst = async (e) => {
    e.preventDefault();
    setTagBtnClicked(!tagBtnClicked);
    // setMapBtnClicked(false);
    if (selectReportTitleDrilldown != "" && CustomeDetailOfReport.title != "") {
      dispatch(
        getlistofcolumnformappingfirst({
          customer_id: user?.customer_id,
          connection_type: CustomeDetailOfReport?.connection_type,
          schema: CustomeDetailOfReport?.schema,
          for_master_report: "yes",
          query: CustomeDetailOfReport.query,
          database_type: user.database_type,
        })
      );
      dispatch(
        getlistofcolumnformappingsecond({
          customer_id: user?.customer_id,
          connection_type: CustomeDetailOfReport?.connection_type,
          schema: CustomeDetailOfReport?.schema,
          for_master_report: "no",
          report_title: selectReportTitleDrilldown,
          database_type: user.database_type,
        })
      );
    } else {
      toast.success("Please fill the missing field value", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      setDrillDownMessage("Please fill the missing field value");
    }
  };

  useEffect(() => {
    if (checkquerysupportdrilldown !== "null") {
      if (checkquerysupportdrilldown?.drilldown === "yes") {
        setcolumnCount(checkquerysupportdrilldown?.column_mapping);
        setSelectColumnForDrill(
          Array.from(
            { length: checkquerysupportdrilldown?.column_mapping },
            () => ({ Master_Column: [], DrillDown_Column: [] })
          )
        );
      }
    } else if (checkquerysupportdrilldown === "null") {
      toast.warn("Query does not support drilldown", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  }, [checkquerysupportdrilldown]);

  useEffect(() => {
    if (getDrilldowndataforupdated !== "null") {
      if (getDrilldowndataforupdated?.drilldown === "yes") {
        const ColumnCount = getDrilldowndataforupdated?.column_mapping || 0;
        const drilldownreportname =
          getDrilldowndataforupdated?.drilldown_data.drilldown_report || "";
        setcolumnCount(ColumnCount);
        const rawDateColumn =
          getDrilldowndataforupdated?.drilldown_data?.date_column;
        if (rawDateColumn) {
          try {
            const dateColumn = JSON.parse(rawDateColumn.replace(/'/g, '"'));
            setSelectedColumn({ value: dateColumn[0], label: dateColumn[0] });
          } catch (err) {
            console.error("Invalid JSON in date_column:", rawDateColumn, err);
          }
        }

        setSelectReportTitleDrilldown(drilldownreportname);
        const drilldownColumns = JSON.parse(
          getDrilldowndataforupdated?.drilldown_data.drilldown_column.replace(
            /'/g,
            '"'
          ) || "[]"
        );
        const masterColumns = JSON.parse(
          getDrilldowndataforupdated?.drilldown_data.master_column.replace(
            /'/g,
            '"'
          ) || "[]"
        );
        setSelectColumnForDrill(
          Array.from({ length: ColumnCount }, (_, index) => ({
            Master_Column: masterColumns[index] || "",
            DrillDown_Column: drilldownColumns[index] || "",
          }))
        );
      }
    } else if (getDrilldowndataforupdated === "null") {
      toast.warn("Query does not support drilldown", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  }, [getDrilldowndataforupdated]);

  useEffect(() => {
    if (updateemapdatadrilldown?.StatusCode === 200) {
      dispatch(setDrilldownTypeCheckdashboard(true));
      const CustomeDetailOfReport = JSON.parse(
        localStorage.getItem("customeDetailOfReport")
      );

      if (CustomeDetailOfReport) {
        CustomeDetailOfReport.drilldown_type = "default"; // set default value

        // Save it back to localStorage
        localStorage.setItem(
          "customeDetailOfReport",
          JSON.stringify(CustomeDetailOfReport)
        );
      }
      onClose();
    }
  }, [updateemapdatadrilldown]);

  const handleSelectMap = async (e) => {
    e.preventDefault();
    // setMapBtnClicked((prev) => !prev);
    if (CustomeDetailOfReport.enable_drilldown === "yes" && !tagBtnClicked) {
      toast.success("Please click on the tag button to select the column", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    const payloadvalue = {
      Master_Column: Array.from(
        { length: columnCount },
        (v, i) => columndetailfirst && columndetailfirst[i]
      ),
      DrillDown_Column: Array.isArray(selectColumnForDrill)
        ? selectColumnForDrill.map((val) =>
            typeof val.DrillDown_Column === "string"
              ? val.DrillDown_Column
              : val.DrillDown_Column?.[0] || ""
          )
        : [],
    };

    const newobject = {
      ...payloadvalue,
      customer_id: user.customer_id,
      drilldown_report: selectReportTitleDrilldown,
      new_master_report: CustomeDetailOfReport.title,
      master_report: CustomeDetailOfReport?.title,
      database_type: user.database_type,
      Date_Column: selectedColumn?.value ? [selectedColumn?.value] : [],
      type: "update",
    };
    if (CustomeDetailOfReport.type !== "Box") {
      dispatch(updateMapDataForDrillDown(newobject));
    } else {
      const emptyPayload = {
        Master_Column: [],
        DrillDown_Column: [],
      };
      const newobject2 = {
        ...emptyPayload,
        customer_id: user.customer_id,
        drilldown_report: selectReportTitleDrilldown,
        new_master_report: CustomeDetailOfReport.title,
        master_report: CustomeDetailOfReport?.title,
        database_type: user.database_type,
        Date_Column: selectedColumn?.value ? [selectedColumn?.value] : [],
        type: "update",
      };
      dispatch(updateMapDataForDrillDown(newobject2));
    }
  };

  const customStylesForSelect = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure this is above other elements
      position: "absolute", // Explicitly set the position
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the portal has a high z-index
    }),
  };

  const handleSelectColumnForDrillDownSecond = (index) => (selectedOptions) => {
    // Ensure selectedOptions is an array
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
      ? [selectedOptions.value]
      : [];

    setSelectColumnForDrill((prevState) => {
      const updatedColumns = [...prevState];
      if (!updatedColumns[index]) {
        updatedColumns[index] = { DrillDown_Column: [] };
      }
      updatedColumns[index].DrillDown_Column = selectedValues;
      return updatedColumns;
    });
  };

  const getDrillDownColumns = (index) => {
    const currentDrillDownColumn =
      selectColumnForDrill[index]?.DrillDown_Column;
    const drillDownColumn =
      typeof currentDrillDownColumn === "string"
        ? [currentDrillDownColumn] // Wrap string into an array
        : Array.isArray(currentDrillDownColumn) &&
          currentDrillDownColumn.length > 0
        ? currentDrillDownColumn
        : [];

    return drillDownColumn.map((value) => ({ value, label: value }));
  };

  console.log(getDrillDownColumns(0));

  function handleSelectReportforlist(selectedOption) {
    setSelectReportTitleDrilldown(selectedOption?.value || ""); // Safe access
    setDrillDownMessage("");
  }

  const options = reportdetaillist?.length
    ? reportdetaillist
        .filter((item) =>
          CustomeDetailOfReport?.chart_type !== "drillcolumn"
            ? item.report_type === "Table"
            : item.report_type === "Chart"
        )
        .map((report) => ({
          value: report.report_name,
          label: report.report_name,
        }))
    : [];

  return (
    <div>
      <Modal show={open} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="drilldown-modal-title">
            Map Drill Down Report
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loader ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div
              style={{ minWidth: normalCustomQueryInputWidth }}
              className="drilldown-custome-mapping-container"
            >
              <div className="drilldownquery-sub-cnt">
                {drilldownmessage != null ? <p>{drilldownmessage}</p> : null}
                <div className="drilldownquery-well form-horizon">
                  <div className="drilldown-custome-container-column">
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        type="text"
                        value={CustomeDetailOfReport.title}
                        disabled
                        required
                        placeholder="Report Name"
                        style={{
                          background: "#f5f6fa",
                          border: "1px solid #d1d5db",
                          borderRadius: 8,
                          color: "#222",
                          fontWeight: 500,
                          fontSize: 15,
                          padding: "10px 14px",
                          boxShadow: "none",
                          opacity: 1,
                          cursor: "not-allowed",
                        }}
                      />
                    </Form.Group>
                    <div className="drilldown-reportMappinAndTaggingDiv">
                      <Select
                        className="drilldown-ReportNameForMapping drilldown-columnSelectCustomQuery"
                        value={{
                          value: selectReportTitleDrilldown || "",
                          label:
                            selectReportTitleDrilldown || "Select report name",
                        }}
                        onChange={handleSelectReportforlist}
                        options={options}
                        isSearchable
                        placeholder="Select report name"
                        styles={{
                          ...customStylesForSelect,
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: 44,
                            borderRadius: 8,
                            borderColor: state.isFocused
                              ? "#4bb9da"
                              : "#d1d5db",
                            boxShadow: state.isFocused
                              ? "0 0 0 2px #e3f6fc"
                              : "none",
                            background: "#f5f6fa",
                            fontSize: 15,
                            fontWeight: 500,
                            color: "#222",
                            paddingLeft: 2,
                            transition: "border-color 0.2s",
                            width: 320, // <-- Set your desired width here (in px)
                            maxWidth: "100%",
                          }),
                          // ...other style overrides...
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />

                      <div className="drilldown-reportTaggingButton">
                        <Button
                          className="drilldown-primary-btn"
                          style={{ margin: "5px" }}
                          onClick={handleSelectReportNamedropfirst}
                        >
                          Tag
                        </Button>
                      </div>
                    </div>
                  </div>
                  {CustomeDetailOfReport.type !== "Box" &&
                    Array.from({ length: columnCount }, (v, i) => (
                      <div
                        className="drilldown-custome-container-column"
                        key={i}
                      >
                        <Form.Group controlId="formBasicEmail">
                          <Form.Control
                            type="text"
                            value={
                              getDrilldowndataforupdated?.drilldown_data
                                ?.master_column
                                ? JSON.parse(
                                    getDrilldowndataforupdated?.drilldown_data.master_column.replace(
                                      /'/g,
                                      '"'
                                    )
                                  )[i]
                                : columndetailfirst && columndetailfirst[i]
                            }
                            disabled
                            required
                            placeholder="Select Master Column"
                            style={{
                              background: "#f5f6fa",
                              border: "1px solid #d1d5db",
                              borderRadius: 8,
                              color: "#222",
                              fontWeight: 500,
                              fontSize: 15,
                              padding: "10px 14px",
                              boxShadow: "none",
                              opacity: 1,
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                        <div
                          style={{
                            flex: 1,
                            float: "right",
                            maxWidth: "72% !important",
                          }}
                        >
                          {" "}
                          <Select
                            className="drilldown-adjustment-style"
                            isSearchable
                            options={
                              columndetailsecond?.map((column) => ({
                                value: column,
                                label: column,
                              })) || []
                            }
                            value={getDrillDownColumns(i)}
                            onChange={handleSelectColumnForDrillDownSecond(i)}
                            placeholder="Select DrillDown Column"
                            menuPortalTarget={document.body} // Render menu in a portal
                            menuPosition="fixed"
                            styles={{
                              ...customStylesForSelect,
                              control: (provided, state) => ({
                                ...provided,
                                minHeight: 44,
                                borderRadius: 8,
                                borderColor: state.isFocused
                                  ? "#4bb9da"
                                  : "#d1d5db",
                                boxShadow: state.isFocused
                                  ? "0 0 0 2px #e3f6fc"
                                  : "none",
                                background: "#f5f6fa",
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#222",
                                paddingLeft: 2,
                                transition: "border-color 0.2s",
                                width: 320, // <-- Set your desired width here (in px)
                                maxWidth: "100%",
                              }),
                              // ...other style overrides...
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  {CustomeDetailOfReport.enable_range_filter === "yes" && (
                    <div className="drilldown-custome-container-column">
                      <Form.Group controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          value={"Duration"}
                          disabled
                          required
                          placeholder="Report Name"
                          style={{
                            background: "#f5f6fa",
                            border: "1px solid #d1d5db",
                            borderRadius: 8,
                            color: "#222",
                            fontWeight: 500,
                            fontSize: 15,
                            padding: "10px 14px",
                            boxShadow: "none",
                            opacity: 1,
                            cursor: "not-allowed",
                          }}
                        />
                      </Form.Group>
                      <div className="drilldown-reportMappinAndTaggingDiv">
                        <Select
                          className="drilldown-ReportNameForMapping drilldown-columnSelectCustomQuery"
                          value={selectedColumn}
                          onChange={(option) => setSelectedColumn(option)}
                          options={
                            columndetailsecond?.map((column) => ({
                              value: column,
                              label: column,
                            })) || []
                          }
                          isSearchable
                          placeholder="Select report name"
                          styles={{
                            ...customStylesForSelect,
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: 44,
                              borderRadius: 8,
                              borderColor: state.isFocused
                                ? "#4bb9da"
                                : "#d1d5db",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px #e3f6fc"
                                : "none",
                              background: "#f5f6fa",
                              fontSize: 15,
                              fontWeight: 500,
                              color: "#222",
                              paddingLeft: 2,
                              transition: "border-color 0.2s",
                              width: 320, // <-- Set your desired width here (in px)
                              maxWidth: "100%",
                            }),
                            // ...other style overrides...
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />

                        <div className="drilldown-reportTaggingButton">
                          <Button
                            className="drilldown-primary-btn"
                            style={{ margin: "5px" }}
                            onClick={handleSelectMap}
                          >
                            Map
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                  {CustomeDetailOfReport.enable_range_filter === "no" && (
                    <div>
                      <Button
                        className="drilldown-primary-btn"
                        style={{ margin: "5px" }}
                        onClick={handleSelectMap}
                      >
                        Map
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="drilldown-primary-btn" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UpdateDefaultCreateDrillDown;
